const ProfitLossPage = () => {
  return <div>Profit & Loss: Under Construction</div>;
};

export default ProfitLossPage;
